import React from 'react'
import Counter from '../Counter/Counter'

const Count = () => {
  return (
    <div>      
      {/* COUNTER SECTION */}
      <section className="tw-py-10" id="conversion">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-12">

              <div
                className="tw-mt-[60px] md:tw-mt-[00px]
                tw-rounded-[20px] tw-p-6 sm:tw-p-8 md:tw-p-10
                tw-bg-gradient-to-b
                tw-from-transparent
                tw-to-[#aadfbda8]"
              >          
              <div className="achievement-section tw-grid tw-grid-cols-1 md:tw-grid-cols-6 tw-gap-6 tw-items-start">

                  <div className="xl:tw-col-span-3 sm:tw-col-span-6">
                    <h3 className="tw-text-3xl sm:tw-text-4xl !tw-font-semibold tw-text-[#157438]">
                      We design and develop better for seamless operations
                    </h3>
                  </div>

                  <div className="xl:tw-col-span-1 sm:tw-col-span-2 tw-text-left ">
                    <h4 className="tw-text-4xl sm:tw-text-5xl !tw-font-bold tw-text-[#157438]">
                      <Counter end={70} suffix="+" />
                    </h4>
                    <p className="text-sm text-left ">Years of Combined experience</p>
                  </div>

                  <div className="xl:tw-col-span-1 sm:tw-col-span-2 tw-text-left">
                    <h4 className="tw-text-4xl sm:tw-text-5xl !tw-font-bold tw-text-[#157438]">
                      <Counter end={200} suffix="+" />
                    </h4>
                    <p className="text-sm">Projects completed</p>
                  </div>

                  <div className="xl:tw-col-span-1 sm:tw-col-span-2 tw-text-left">
                    <h4 className="tw-text-4xl sm:tw-text-5xl !tw-font-bold tw-text-[#157438]">
                      <Counter end={25} suffix="+" />
                    </h4>
                    <p className="text-sm">Clients worked With</p>
                  </div>
                </div> 
              </div>              
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Count
